var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPoliceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    preserveAspectRatio: "xMidYMid meet",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.72 78.24c-1.34-2.44.13-4.91 2.67-7.94c4-4.77 7.96-15.61 3.19-26.32c.02-.06-.91-1.83-.89-1.89l-1.71-.09c-.55-.08-19.26-.12-37.98-.12c-18.72 0-37.43.04-37.98.12c0 0-2.62 1.92-2.6 1.98c-4.77 10.71-.8 21.55 3.19 26.32c2.54 3.03 4.01 5.5 2.67 7.94c-1.31 2.39-4.92 2.74-4.92 2.74s.71 2.46 2.66 3.79c1.81 1.23 4.08 1.53 5.66 1.57c0 0 5.89 9.47 22.23 9.47H73.1c16.34 0 22.23-9.47 22.23-9.47c1.58-.04 3.85-.33 5.66-1.57c1.94-1.33 2.66-3.79 2.66-3.79s-3.62-.36-4.93-2.74z",
    fill: "#543930"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab19652",
    cx: 99.568,
    cy: 47.313,
    r: 24.68,
    gradientTransform: "matrix(1 0 0 .4912 -20.914 57.446)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#6d4c41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.99 95.79V85.3l28.59-2.47l2.74 3.5s-5.89 9.47-22.23 9.47l-9.1-.01z",
    fill: "url(#IconifyId17ecdb2904d178eab19652)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab19653",
    cx: 76.66,
    cy: 50.992,
    r: 7.158,
    gradientTransform: "matrix(-.9057 .4238 -.3144 -.6719 187.027 78.778)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#6d4c41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.07 81.82c-4.51-7 4.78-9.59 4.78-9.59l.01.01c-1.54 2.18-2.2 4.1-1.16 6c1.31 2.39 4.92 2.74 4.92 2.74s-4.68 4.75-8.55.84z",
    fill: "url(#IconifyId17ecdb2904d178eab19653)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab19654",
    cx: 95.367,
    cy: 71.203,
    r: 31.197,
    gradientTransform: "matrix(-.0746 -.9972 .8311 -.0622 30.795 156.327)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#6d4c41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104.6 43.98c4.64 10.37.9 21.33-2.97 26.05c-.54.65-2.83 3.19-3.29 5.23c0 0-9.89-13.98-12.89-21.98c-.6-1.6-1.14-3.23-1.25-4.91c-.08-1.26.07-2.74.73-3.8c.81-1.3 19.14-1.68 19.14-1.68c-.01.01.53 1.09.53 1.09z",
    fill: "url(#IconifyId17ecdb2904d178eab19654)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab19655",
    cx: 45.167,
    cy: 71.203,
    r: 31.197,
    gradientTransform: "matrix(.0746 -.9972 -.8311 -.0622 100.972 106.267)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#6d4c41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.42 43.98c-4.64 10.37-.9 21.33 2.98 26.05c.54.65 2.83 3.19 3.29 5.23c0 0 9.89-13.98 12.89-21.98c.6-1.6 1.14-3.23 1.25-4.91c.08-1.26-.07-2.74-.73-3.8c-.81-1.3-1.81-.95-3.25-.95c-2.74 0-14.71-.73-15.64-.73c0 .01-.79 1.09-.79 1.09z",
    fill: "url(#IconifyId17ecdb2904d178eab19655)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab19656",
    cx: 49.369,
    cy: 47.313,
    r: 24.68,
    gradientTransform: "matrix(-1 0 0 .4912 98.738 57.446)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#6d4c41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.03 95.79V85.3l-28.59-2.47l-2.74 3.5s5.89 9.47 22.23 9.47l9.1-.01z",
    fill: "url(#IconifyId17ecdb2904d178eab19656)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab19657",
    cx: 26.461,
    cy: 50.992,
    r: 7.158,
    gradientTransform: "matrix(.9057 .4238 .3144 -.6719 -13.537 100.053)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#6d4c41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.95 81.82c4.51-7-4.78-9.59-4.78-9.59l-.01.01c1.54 2.18 2.2 4.1 1.16 6c-1.31 2.39-4.92 2.74-4.92 2.74s4.69 4.75 8.55.84z",
    fill: "url(#IconifyId17ecdb2904d178eab19657)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab19658",
    gradientUnits: "userSpaceOnUse",
    x1: 64,
    y1: 31.528,
    x2: 64,
    y2: 2.285,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#3b78e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#386eda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.629,
    stopColor: "#3052b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283593"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64.14 96H64c-25.65.03-52 7.1-52 24.99V124h104v-3.01C116 104.12 89.9 96 64.14 96z",
    fill: "url(#IconifyId17ecdb2904d178eab19658)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.32 106.27s6.88.59 13.84 2.73c13 4 16.91-2.86 16.91-2.86s-14.22-9.32-32.22-9.45c0 0-1.19 8.85 1.47 9.58z",
    fill: "#283593"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.59 106s4 7 17 3c6.96-2.14 13.84-2.73 13.84-2.73c2.66-.73 1.47-9.58 1.47-9.58c-18 .12-32.31 9.31-32.31 9.31z",
    fill: "#283593"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M45.75 119.71H34.83c-1.2 0-2.17-.97-2.17-2.17s.97-2.17 2.17-2.17h10.92c1.2 0 2.17.97 2.17 2.17s-.97 2.17-2.17 2.17z",
    fill: "#e0e0e0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab19659",
    gradientUnits: "userSpaceOnUse",
    x1: 116.379,
    y1: 9.418,
    x2: 106.54,
    y2: 9.418,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M113.88 113.17l-5 .08l-2.34 4.29l4.83 6.46h4.99c.26-7.38-2.48-10.83-2.48-10.83z",
    fill: "url(#IconifyId17ecdb2904d178eab19659)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab19660",
    gradientUnits: "userSpaceOnUse",
    x1: 11.575,
    y1: 9.418,
    x2: 21.414,
    y2: 9.418,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.08 113.25l-5-.08s-2.74 3.46-2.48 10.83h4.99l4.83-6.46l-2.34-4.29z",
    fill: "url(#IconifyId17ecdb2904d178eab19660)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#bdbdbd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.33 113.99l4.56-.08c.41-.01.74-.35.74-.76s-.32-.71-.76-.74l-5.44.09l-3.02 5.55l4.23 5.95h1.84l-4.31-6.05l2.16-3.96z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.84 116.69l3.38-.14c.28-.01.49-.24.48-.52c-.01-.28-.25-.47-.52-.48l-3.87.16l-1.57 2.28l3.95 6.01h1.2l-3.94-5.99l.89-1.32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.53 112.51l-5.44-.09h-.01c-.41 0-.74.33-.75.74c-.01.41.32.76.74.76l4.57.08l2.15 3.96l-4.32 6.04h1.84l4.23-5.95l-3.01-5.54z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.65 115.71l-3.88-.16c-.28.01-.51.2-.52.48c-.01.28.2.51.48.52l3.38.14l.91 1.31l-3.94 6h1.2l3.95-6.01l-1.58-2.28z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M63.99 121.94l9.32-17.08h-19.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M54.92 86.08v13.98c0 4.51 3.7 8.17 8.26 8.17h1.65c4.56 0 8.26-3.66 8.26-8.17V86.08H54.92z",
    fill: "#e59600"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#3674ce",
    d: "M47.1 97.18l-8 16.22l10.87-3.26l14.02 11.8l-9.11-25.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3674ce",
    d: "M73.12 96.27l-9.11 25.67l14.8-11.64l10.09 3.1l-8-16.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M91.33 50.43H36.67c-5.89 0-10.71 5.14-10.71 11.41s4.82 11.41 10.71 11.41H91.32c5.89 0 10.71-5.14 10.71-11.41s-4.81-11.41-10.7-11.41z",
    fill: "#e59600"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M64 11.07c-17.4 0-33.52 18.61-33.52 45.4c0 26.64 16.61 39.81 33.52 39.81S97.52 83.1 97.52 56.46c0-26.78-16.12-45.39-33.52-45.39z",
    fill: "#ffca28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.42 76.14c-3.18 1.89-13.63 1.89-16.81 0c-1.83-1.09-3.7.58-2.94 2.24c.75 1.63 6.44 5.42 11.37 5.42s10.55-3.79 11.3-5.42c.75-1.66-1.09-3.33-2.92-2.24z",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.86 68.06c-.11-.04-.21-.07-.32-.08h-7.08c-.11.01-.22.04-.32.08c-.64.26-.99.92-.69 1.63c.3.71 1.71 2.69 4.55 2.69s4.25-1.99 4.55-2.69c.3-.71-.05-1.37-.69-1.63z",
    fill: "#e59600"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#404040"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 47.56,
    cy: 58.81,
    rx: 4.93,
    ry: 5.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.44,
    cy: 58.81,
    rx: 4.93,
    ry: 5.1
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#6d4c41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.8 49.82c-.93-1.23-3.07-3.01-7.23-3.01s-6.31 1.79-7.23 3.01c-.41.54-.31 1.17-.02 1.55c.26.35 1.04.68 1.9.39s2.54-1.16 5.35-1.18c2.81.02 4.49.89 5.35 1.18c.86.29 1.64-.03 1.9-.39c.28-.38.39-1.01-.02-1.55z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.67 49.82c-.93-1.23-3.07-3.01-7.23-3.01s-6.31 1.79-7.23 3.01c-.41.54-.31 1.17-.02 1.55c.26.35 1.04.68 1.9.39s2.54-1.16 5.35-1.18c2.81.02 4.49.89 5.35 1.18c.86.29 1.64-.03 1.9-.39c.28-.38.39-1.01-.02-1.55z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M101.15 23.27c-2.42-3.44-7.65-8-12.16-8.3c-.86-4.3-5.56-7.89-10.03-9.28c-11.99-3.72-19.78.45-24 2.72c-.88.47-6.59 3.58-10.5 1.35c-2.44-1.39-10.1-2.24-7.76 5.97c-2.69.11-6.27 1.25-8.32 5.05c-2.47 4.58-1.86 8.45-1.3 10.32c-2.47 2.05-5.69 6.45-3.94 12.23c1.33 4.41 7.5 6.46 7.5 6.46c-.79 8.12-.63 13.2.06 15.27c.12.36.61.33.71-.05c1.13-4.11 5.96-18.13 5.73-20.52c0 0 10.86-2.22 21.2-9.98c2.08-1.56 4.32-2.88 6.7-3.85c12.63-5.13 15.47 3.66 15.47 3.66s8.8-1.74 11.94 11.02c1.2 4.89 3.39 12.85 4.2 18.52c.06.4.57.49.71.12c.84-2.26 1.31-6.7 1.56-11.19c.08-1.56 4-3.62 5.38-10.24c1.81-8.64-1.38-16.77-3.15-19.28z",
    fill: "#543930"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab19661",
    cx: 80.442,
    cy: 87.144,
    r: 34.378,
    gradientTransform: "matrix(.3076 .9515 .706 -.2282 -5.827 -15.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#6d4c41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M98.9 52.83c.08-1.56 4-3.62 5.38-10.24c.14-.7.26-1.4.37-2.12c.95-7.84-1.87-14.9-3.49-17.21c-2.24-3.18-6.88-7.32-11.13-8.15c-.37-.05-.73-.09-1.07-.11c0 0 .37 1.97-.38 3.55c-.97 2.06-3.07 2.55-3.07 2.55C97.07 32.42 96.68 42.15 98.9 52.83z",
    fill: "url(#IconifyId17ecdb2904d178eab19661)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab19662",
    cx: 157.584,
    cy: 62.016,
    r: 26.344,
    gradientTransform: "matrix(-.9378 -.3944 -.2182 .5285 229.242 48.969)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#6d4c41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.72 5.33c6.67 1.77 10.02 5.12 11.26 9.65c.37 1.34 1.19 14.06-23.14-.36c-8.81-5.23-6.39-8.46-5.36-8.83c4-1.43 9.8-2.43 17.24-.46z",
    fill: "url(#IconifyId17ecdb2904d178eab19662)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab19663",
    cx: 44.226,
    cy: 102.075,
    r: 15.13,
    gradientTransform: "matrix(-.9657 -.2598 -.2432 .9037 111.758 -54.83)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#6d4c41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.1 16.43l-4.39-.71c-.17 0-.76.05-1.08.1c-2.5.35-5.49 1.63-7.24 4.95c-1.9 3.6-2 6.73-1.64 8.82c.1.71.34 1.5.34 1.5s2.33-2.15 7.63-2.29l6.38-12.37z",
    fill: "url(#IconifyId17ecdb2904d178eab19663)"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "IconifyId17ecdb2904d178eab19664",
    cx: 40.498,
    cy: 87.078,
    r: 16.513,
    gradientTransform: "matrix(.9907 .1363 .1915 -1.3921 -16.296 156.623)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#6d4c41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.87 31.28c-2.33 2.02-5.58 6.55-3.65 12.25c1.47 4.35 7.44 6.26 7.44 6.26c0 .02 1.2.4 1.82.4l2.25-21.38c-2.83 0-5.58.86-7.4 2.11c0 .03-.47.33-.46.36z",
    fill: "url(#IconifyId17ecdb2904d178eab19664)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab19665",
    gradientUnits: "userSpaceOnUse",
    x1: 64.056,
    y1: 103.667,
    x2: 64.056,
    y2: 82.887,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#3f3f3f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M63.79 24.22c-33.6 0-38.98 11.36-38.98 11.36s10.36 9.91 38.98 10.1c28.63-.19 39.51-10.73 39.51-10.73s-5.91-10.73-39.51-10.73z",
    fill: "url(#IconifyId17ecdb2904d178eab19665)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "IconifyId17ecdb2904d178eab19666",
    gradientUnits: "userSpaceOnUse",
    x1: 64,
    y1: 123.648,
    x2: 64,
    y2: 93.687,
    gradientTransform: "matrix(1 0 0 -1 0 128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.003,
    stopColor: "#3b78e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.011,
    stopColor: "#3b77e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.298,
    stopColor: "#335bc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568,
    stopColor: "#2d46a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#293998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#283593"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.96 34.5c1.71 6.19 3.35 8.81 3.35 8.81C25.04 41.31 35.35 32 63.93 32h.16c28.58 0 38.42 9.36 40.16 11.36c0 0 2.07-2.8 3.78-8.99C112 20.05 92.35 4 64.06 4c-28.23 0-48.05 16.2-44.1 30.5z",
    fill: "url(#IconifyId17ecdb2904d178eab19666)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.04 35.61a4.614 4.614 0 0 0-1.74-2.81c-3.78-2.9-15.09-10.1-34.24-10.1c-19.65 0-30.65 7.19-34.3 10.1c-.87.69-1.46 1.67-1.67 2.75l-.01.06c-.25 1.32.09 2.56.79 3.54C34.7 35.86 45.53 32 63.93 32h.16c18.7 0 29.38 4.01 35.01 7.34c.81-.99 1.21-2.32.94-3.73z",
    fill: "#3b78e7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M71.28 13.2c-.26 0-.5.12-.64.33c-.55.84-1.36 1.4-2.79 1.4c-1.39 0-2.4-1.28-3.01-2.07c-.19-.25-.49-.41-.82-.41c-.33 0-.63.16-.82.41c-.6.79-1.56 2.07-2.95 2.07c-1.43 0-2.24-.57-2.79-1.4a.76.76 0 0 0-.64-.33c-.24 0-.47.11-.61.29l-.31.4c-.37.48-.43 1.12-.15 1.65c.42.8.64 1.68.64 2.57v3.48c0 2.54 4.14 7.72 7.65 7.72s7.65-5.18 7.65-7.72v-3.48c0-.89.22-1.77.64-2.57c.28-.53.22-1.17-.15-1.65l-.31-.4c-.12-.18-.35-.29-.59-.29z",
    fill: "#fc0"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoliceIcon);
export default __webpack_public_path__ + "static/media/policeIcon.372dec155d5c201ce6fff1d775826cc9.svg";
export { ForwardRef as ReactComponent };